import { FC, useRef, useState, useEffect } from "react";
import { Tooltip } from "antd";

interface TextAutoTruncateProps {
  children?: string;
  className?: string;
}

const TextAutoTruncate: FC<TextAutoTruncateProps> = ({ children, className }) => {
  const textRef = useRef<HTMLParagraphElement>(null);
  const [isTruncated, setIsTruncated] = useState(false);

  useEffect(() => {
    const el = textRef.current;
    if (el) {
      setIsTruncated(el.scrollWidth > el.clientWidth);
    }
  }, [children]);

  const textP = (
    <p
      ref={textRef}
      className= {`${className}  whitespace-nowrap overflow-hidden max-w-full text-ellipsis align-middle`}
    >
      {children}
    </p>
  );

  return isTruncated ? (
    <Tooltip title={children || ""}>
      {textP}
    </Tooltip>
  ) : (
    textP 
  );
};

export default TextAutoTruncate;
